import { createSelector } from 'reselect';
import type AppState from '../../../redux/types/AppState';
import type { PromotionState } from '../reducers/promotionReducer';

const getPromotionsState = (state: AppState): PromotionState => state.promotion;

export const getProposedPromotions = createSelector(getPromotionsState, promotionState => promotionState.promotions.filter(p => p.isInState('PROPOSED')));



// WEBPACK FOOTER //
// ./src/advertisers/modules/promotions/selectors/promotionSelectors.js